import React from "react";
import "./Footer.css";

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-info">
          <h3>Doggie Dawg</h3>
          <p className="footer-motto">"Your Dog's Other Best Friend"</p>
          <p>© {new Date().getFullYear()} Doggie Dawg, LLC</p>
        </div>
        <div className="footer-logo-section">
          <img src="/doggiedawg-logo.webp" alt="" aria-hidden="true" className="footer-logo" loading="lazy" decoding="async" />
        </div>
        <div className="footer-contact">
          <p>
            <a href="tel:5128504101">(512) 850-4101</a>
          </p>
          <p>
            <a href="mailto:contact@doggiedawg.com">
              contact@doggiedawg.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
